// src/app/core/interceptors/if-match.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';

type WithLockVersion = { lockVersion: number | string };

function hasLockVersion(body: unknown): body is WithLockVersion {
  return !!body && (typeof (body as any).lockVersion === 'number' || typeof (body as any).lockVersion === 'string');
}

export const ifMatchInterceptor: HttpInterceptorFn = (req, next) => {
  const needsIfMatch = req.method === 'PUT' || req.method === 'PATCH' || req.method === 'DELETE';

  if (needsIfMatch && hasLockVersion(req.body)) {
    req = req.clone({
      setHeaders: { 'If-Match': `"${String(req.body.lockVersion)}"` }
    });
  }

  return next(req);
};
